import { createSlice } from "@reduxjs/toolkit";
import { updateDiscount } from "services/student/student";

const initialState = {
    dis : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const registerDiscountSlice = createSlice({
    name: 'registerDiscount',
    initialState,
    extraReducers: {
        [updateDiscount.pending]: (state) => {
            state.dis.isLoading = true;
        },
        [updateDiscount.fulfilled]: (state, { payload }) => {
            state.dis.isLoading = false;
            state.dis.isSuccess = true;
            state.dis.data = payload;
        },
        [updateDiscount.rejected]: (state, { payload }) => {
            state.dis.isLoading = false;
            state.dis.isSuccess = false;
            state.dis.errorMessage = payload
        }
    }
})

export default registerDiscountSlice.reducer;